
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.DistanceCustomer = {

  template() {
    return {
      tag: 'div',
      items: [
        {
          items: [
            {
              tag: 'label',
              items: [
                {
                  tag: 'span',
                  html: Monet.I18n.getResourcesByKey('event.distance.checkcustomer'),
                  attributes: {
                    class: 'i18nResource',
                  },
                },
              ],
              attributes: {
                class: 'control-label',
                for: 'checkOnlyRouteCustomers',
                style: 'display: inline;',
              },
            },
            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    'type': 'checkbox',
                    'name': 'checkOnlyRouteCustomers',
                    'id': 'checkOnlyRouteCustomers',
                    class: 'modelAttribute checkBoxField mandatory',
                  },
                },
              ],
              attributes: {
                class: 'controls',
                style: 'display: inline;',
              },
            },
            {
              tag: 'label',
              items: [
                {
                  tag: 'span',
                  html: Greenmile.Utils.getResourceWithUnitMetric('event.distance.radius'),
                  attributes: {
                    'class': 'i18nResource',
                  },
                },
              ],
              attributes: {
                class: 'control-label',
                for: 'distanceMeters',
                style: 'margin-top: 7px;',
              },
            },
            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    type: 'text',
                    maxlength: '10',
                    'name': 'distanceMeters',
                    id: 'distanceMeters',
                    class: 'modelAttribute textField mandatory',
                    'autocomplete': 'off',
                  },
                },
              ],
              attributes: {
                class: 'controls',
              },
            },
            {
              tag: 'label',
              items: [
                {
                  tag: 'span',
                  attributes: {
                    class: 'i18nResource',
                  },
                },
              ],
              html: Greenmile.Utils.getResourceWithUnitMetric('event.distance.operator'),
              attributes: {
                class: 'control-label i18nResource',
                for: 'operator',
              },
            },
            {
              items: [
                {
                  tag: 'select',
                  items: [
                    {
                      tag: 'option',
                      'html': Greenmile.Utils.getResourceWithUnitMetric('event.distance.greaterThan'),
                      'attributes': {
                        class: 'i18nResource',
                        "value": '&gt;',
                      },
                      
                    },
                    {
                      tag: 'option',
                      html: Greenmile.Utils.getResourceWithUnitMetric('event.distance.greaterEqualTo'),
                      'attributes': {
                        class: 'i18nResource',
                        "value": '&gt;=',
                      },
                    },
                    {
                      'tag': 'option',
                      'html': Greenmile.Utils.getResourceWithUnitMetric('event.distance.lesserThan'),
                      'attributes': {
                        class: 'i18nResource',
                        "value": '&lt;',
                      },
                    },
                    {
                      'tag': 'option',
                      html: Greenmile.Utils.getResourceWithUnitMetric('event.distance.lesserEqualTo'),
                      'attributes': {
                        class: 'i18nResource',
                        "value": '&lt;=',
                      },
                    },
                  ],
                  attributes: {
                    name: 'operator',
                    'id': 'operator',
                    class: 'modelAttribute selectField mandatory',
                  },
                },
              ],
              attributes: {
                class: 'controls',
              },
            },
          ],
          attributes: {
            class: 'control-group',
          },
        },
      ],
    };
  },

  assignParameter(jsonParam) {
    let value,
      formatedValue;

    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);

      if (Monet.Session.User.unitSystem !== 'METRIC') {
        value = new BigInt(jsonParam.distanceMeters) * 0.00062137;
        formatedValue = ((Math.round(value * 100)) / 100);
      } else {
        formatedValue = jsonParam.distanceMeters;
      }

      $('#distanceMeters').val(formatedValue);
      $('#operator').val(jsonParam.operator);
      $('#checkOnlyRouteCustomers').attr(
        'checked',
        jsonParam.checkOnlyRouteCustomers
      );
    }
  },
  retrieveParameter() {
    let distance,
      checkOnlyRouteCustomers,
      operator;

    if (Monet.Session.User.unitSystem !== 'METRIC') {
      distance = $('#distanceMeters').val() / 0.00062137;
    } else {
      distance = $('#distanceMeters').val();
    }

    distance = parseInt(distance, 10);
    checkOnlyRouteCustomers = $('#checkOnlyRouteCustomers').is(':checked');
    operator = $('#operator option:selected').val();

    return JSON.stringify({
      checkOnlyRouteCustomers,
      distanceMeters: distance,
      operator,
    });
  },

};
